export default "__VITE_ASSET__BVLzQfhS__"